<template>
  <div class="upload-container">
    <el-button :style="{background:color,borderColor:color}" icon="el-icon-upload" size="mini" type="primary" @click=" dialogVisible=true">Upload Image
    </el-button>
    <el-dialog :visible.sync="dialogVisible">
      <el-upload
        :multiple="true"
        :file-list="fileList"
        :show-file-list="true"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
        :on-error="handleError"
        :before-upload="beforeUpload"
        :http-request="uploadImage"
        class="editor-slide-upload"
        action="unused"
        accept="image/*"
        list-type="picture-card">
        <el-button size="small" type="primary">Upload</el-button>
      </el-upload>
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </el-dialog>
  </div>
</template>

<script>
import * as qiniu from 'qiniu-js'
import { getSingaporeQiniuToken } from '../../../api/examAdmin'

const IMAGE_DOMAIN = 'https://ap.learningfirst.io/'

export default {
  name: 'EditorSlideUpload',
  props: {
    color: {
      type: String,
      default: '#1890ff'
    }
  },
  data () {
    return {
      dialogVisible: false,
      listObj: {},
      fileList: []
    }
  },
  methods: {
    checkAllSuccess () {
      const items = Object.keys(this.listObj)
      return items.length > 0 && items.every(item => this.listObj[item].hasSuccess)
    },
    handleSubmit () {
      const arr = Object.keys(this.listObj).map(v => this.listObj[v])
      if (arr.length === 0) {
        this.$message('请先选择并上传图片')
        return
      }
      if (!this.checkAllSuccess()) {
        this.$message('请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！')
        return
      }
      this.$emit('successCBK', arr)
      this.listObj = {}
      this.fileList = []
      this.dialogVisible = false
    },
    handleSuccess (response, file) {
      const item = this.listObj[file.uid]
      if (item) {
        item.url = response.url
        item.hasSuccess = true
        file.url = response.url
      }
    },
    handleError (error, file) {
      if (this.listObj[file.uid]) {
        this.$delete(this.listObj, file.uid)
      }
      const message = error && error.message ? error.message : '网络异常'
      this.$message.error(`图片 ${file.name} 上传失败：${message}`)
    },
    handleRemove (file) {
      if (this.listObj[file.uid]) {
        this.$delete(this.listObj, file.uid)
      }
    },
    beforeUpload (file) {
      if (!file.type || file.type.indexOf('image/') !== 0) {
        this.$message.error(`${file.name} 不是图片文件`)
        return false
      }
      if (file.size > 20 * 1024 * 1024) {
        this.$message.error(`${file.name} 超过 20MB，无法上传`)
        return false
      }
      this.$set(this.listObj, file.uid, {
        hasSuccess: false,
        hasError: false,
        uid: file.uid,
        name: file.name,
        url: ''
      })
      return true
    },
    uploadImage (options) {
      let subscription = null
      let aborted = false
      const request = {
        abort () {
          aborted = true
          if (subscription) {
            subscription.unsubscribe()
          }
        }
      }

      getSingaporeQiniuToken().then(result => {
        if (aborted) {
          return
        }
        if (!result.data || result.data.code !== 0 || !result.data.data) {
          throw new Error((result.data && result.data.msg) || '无法获取上传凭证')
        }

        const file = options.file
        const extensionIndex = file.name.lastIndexOf('.')
        const extension = extensionIndex >= 0 ? file.name.slice(extensionIndex).toLowerCase() : ''
        const key = `exam-system/material/${Date.now()}-${file.uid}${extension}`
        const observable = qiniu.upload(
          file,
          key,
          result.data.data,
          {},
          { region: qiniu.region.as0, useCdnDomain: true }
        )
        subscription = observable.subscribe({
          next: progress => {
            options.onProgress({ percent: progress.total.percent })
          },
          error: error => {
            options.onError(error)
          },
          complete: response => {
            options.onSuccess({
              key: response.key,
              url: IMAGE_DOMAIN + response.key
            })
          }
        })
      }).catch(error => {
        if (!aborted) {
          options.onError(error)
        }
      })

      return request
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.editor-slide-upload {
  margin-bottom: 20px;
  ::v-deep .el-upload--picture-card {
    width: 100%;
  }
}
</style>
